<template>
  <div>
    <div class="web-box top-page">
      <a-row>
        <a-col :xs="24" :sm="12" class="top-left">
          <p>微博超级粉丝通/WAX</p>
          <p>国内最大的社交媒体，日均亿级广告流量</p>
          <div class="color-button web-show" @click="goCallUs">
            联系我们
            <span class="button-icon">&#xe63a;</span>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img
            class="jixiangwu"
            src="http://www.vedamobi.com/assets/website/images/weibo/jixiangwu.png"
          />
        </a-col>
      </a-row>
      <p class="home-title product-title">产品介绍</p>
      <a-row>
        <a-col :xs="24" :sm="12">
          <div class="left-card-wrap">
            <div class="left-card">
              <p class="title">微博超级粉丝通</p>
              <p class="subtitle">
                &emsp;&emsp;微博官方搭建的程序化投放平台，覆盖微博亿级优质用户资源，为您带来更高效的广告传播效果。
              </p>
              <div class="flex" style="align-items:flex-start">
                <a-row class="web-show">
                  <a-col :sm="8">
                    <div class="left-content-wrap">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/weibo/icon1.svg"
                      />
                      <h2>海量触达</h2>
                      <p>
                        4.31亿月活用户
                        <br />1.90亿日活用户 <br />覆盖微博亿级优质用户
                      </p>
                    </div>
                  </a-col>
                  <a-col :sm="8">
                    <div class="left-content-wrap">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/weibo/icon2.svg"
                      />
                      <h2>精准定向</h2>
                      <p>
                        微博大数据用户画像
                        <br />4000+用户标签，688个兴趣领域
                        <br />精准定向目标人群
                      </p>
                    </div>
                  </a-col>
                  <a-col :sm="8">
                    <div class="left-content-wrap">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/weibo/icon3.svg"
                      />
                      <h2>多维传播</h2>
                      <p>
                        明星+KOL+亿万用户
                        <br />社交关系助力多维传播 <br />涟漪扩散，聚焦品牌
                      </p>
                    </div>
                  </a-col>
                </a-row>
                <swiper class="mobile-show">
                  <swiper-slide>
                    <div class="left-content-wrap">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/weibo/icon2.svg"
                      />
                      <h2>精准定向</h2>
                      <p>
                        微博大数据用户画像
                        <br />4000+用户标签，688个兴趣领域
                        <br />精准定向目标人群
                      </p>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="left-content-wrap">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/weibo/icon1.svg"
                      />
                      <h2>海量触达</h2>
                      <p>
                        4.31亿月活用户
                        <br />1.90亿日活用户 <br />覆盖微博亿级优质用户
                      </p>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="left-content-wrap">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/weibo/icon3.svg"
                      />
                      <h2>多维传播</h2>
                      <p>
                        明星+KOL+亿万用户
                        <br />社交关系助力多维传播 <br />涟漪扩散，聚焦品牌
                      </p>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="right-card">
            <p class="title">微博WAX（WeiboAdX）</p>
            <p class="subtitle">
              &emsp;&emsp;微博官方建立的流量交易市场，通过实时竞价的模式，广告主可挑选合适的DSP作为服务方，偕行VEDA作为微博核心代理商，为微博数据营销提供强大DMP数据管理引擎助力客户营销。
            </p>
            <div class="img-wrap">
              <img
                src="http://www.vedamobi.com/assets/website/images/weibo/icon4.svg"
              />
            </div>
            <div class="wax-flex">
              <div class="content-wrap">
                <h2>海量用户</h2>
                <p>4.31亿月活用户，1.9亿日活用户，日均过亿级竞价请求</p>
                <h2>数据赋能</h2>
                <p>
                  微博DMP提供各类丰富精准数据，结合DSP技术与数据能力，助力广告主实现精准数字营销
                </p>
                <h2>广告追踪</h2>
                <p>
                  独特的开放型社交生态广告均可与用户产生真实
                  互动与关注效果可评估追踪并可后续建立深度联系
                </p>
              </div>
              <div class="line web-show"></div>
              <div class="content-wrap">
                <h2>自建竞价平台</h2>
                <p>
                  由偕行自研DSP竞价引擎，程序化筛选优质人群，一站式广告流量购买
                </p>
                <h2>DMP数据管理平台</h2>
                <p>
                  结合三方（媒体、偕行、第三方监控平台）数据，不断积累沉淀，构建大数据绿色生态圈
                </p>
                <h2>多种广告形式</h2>
                <p>
                  微博提供Feed流、评论流、BANNER等多种形式的广告，客户可高度自主选择相应的投放形式。
                </p>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>

      <p class="home-title product-title">媒体详情</p>
      <div class="media-wrap">
        <p class="explain">
          &emsp;&emsp;微博（Weibo）是指一个基于用户关系，信息分享、传播以及获取的通过关注机制分享简短实时信息的广播式的社交媒体/网络平台。用户可以通过PC、手机等多种移动终端接入，以文字、图片、视频等多媒体形式，实现信息的即时分享、传播互动。
          <br />&emsp;&emsp;在这里，用户可以随时随地发现新鲜事。微博带你欣赏世界上每一个精彩瞬间，了解每一个幕后故事。分享你想表达的,让全世界都能听到你的心声！
        </p>
        <div class="flex media-content web-show">
          <a-row>
            <a-col :xs="12" :sm="6">
              <p class="icon">&#xe61a;</p>
              <p>
                93%
                <br />移动用户占比
              </p>
            </a-col>
            <a-col :xs="12" :sm="6">
              <p class="icon">&#xe622;</p>
              <p>
                82%
                <br />30岁以下年轻用户
              </p>
            </a-col>
            <a-col :xs="12" :sm="6">
              <p class="icon">&#xe6cb;</p>
              <p>
                56%
                <br />三四线城市用户占比
              </p>
            </a-col>
            <a-col :xs="12" :sm="6">
              <p class="icon">&#xe66c;</p>
              <p>
                77.8%
                <br />高等学历用户占比
              </p>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ScrollReveal from 'scrollreveal'
export default {
  data () {
    return {
      scrollReveal: ScrollReveal()
    }
  },

  mounted () {
    this.scrollReveal.reveal(`.jixiangwu`, {
      duration: 600,
      delay: 0,
      origin: 'right',
      reset: true,
      mobile: false,
      distance: '500px',
      opacity: 0.001,
      easing: 'linear'
    })
  },
  methods: {
    goCallUs () {
      const btn = document.getElementById('callusForm')
      const scrollHeight = btn.offsetTop
      window.scrollTo(0, scrollHeight)
    }
  }
}
</script>
<style lang="scss" scoped>
.top-page {
  overflow: hidden;
  padding-top: 180px;
  .top-left {
    text-align: center;
    p:nth-child(1) {
      margin-top: 160px;
      font-size: 44px;
    }
    p:nth-child(2) {
      font-size: 22px;
    }
    .color-button {
      margin-top: 80px;
    }
  }
  .jixiangwu {
    width: 600px;
    height: 600px;
  }
  .button-icon {
    font-family: iconFont;
    float: right;
    padding-right: 10px;
  }
}
.title {
  font-size: 30px;
  text-align: center;
}
.subtitle {
  padding: 0 40px;
  margin-top: 30px;
  line-height: 50px;
  font-size: 18px;
}
.right-card {
  max-width: 680px;
  min-height: 852px;
  width: 100%;
  background-color: #31375d;
  box-shadow: 0px -1px 8px #b5c0fd;
  border-radius: 10px;
  color: #fff;

  padding: 70px 40px 20px;
  .img-wrap {
    width: 100%;
    text-align: center;
    img {
      width: 100px;
      height: 100px;
    }
  }
  .wax-flex {
    display: flex;
    .content-wrap {
      flex: 1;
      padding: 20px;
      h2 {
        margin-top: 20px;
        color: #fff;
      }
    }
    .line {
      width: 1px;
      height: 340px;
      background-color: #fff;
      margin-top: 40px;
    }
  }
}
.left-card-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 30px;
  justify-content: flex-end;
  .left-card {
    width: 100%;
    padding: 46px 40px 120px 40px;
    max-width: 613px;
    background-color: #fff;
    box-shadow: 0px -1px 8px #b5c0fd;
    border-radius: 10px;
    .left-content-wrap {
      text-align: center;
      flex: 1;
      padding: 10px;
      p {
        line-height: 50px;
      }
      h2 {
        margin-top: 40px;
      }
      img {
        margin-top: 50px;
        width: 80px;
        height: 80px;
      }
    }
  }
}
.media-wrap {
  max-width: 1300px;
  width: 100%;
  padding: 0 40px;
  margin: 0 auto;
  .explain {
    font-size: 20px;
    line-height: 50px;
  }
  .media-content {
    div {
      flex: 1;
      text-align: center;
      margin-top: 40px;
      .icon {
        font-family: 'iconFont';
        font-size: 100px;
        margin: 0;
      }
    }
  }
}
.product-title {
  text-align: center;
  margin-top: 200px;
}
@media (max-width: 750px) {
  .product-title {
    text-align: center;
    margin-top: 40px;
  }
  .top-page {
    overflow: hidden;
    padding-top: 80px;
    min-height: 100vh;
    .top-left {
      text-align: center;
      padding: 0 20px;
      p:nth-child(1) {
        margin-top: 60px;
        font-size: 24px;
      }
      p:nth-child(2) {
        font-size: 18px;
      }
      .color-button {
        margin-top: 30px;
      }
    }
    .jixiangwu {
      width: 100%;
      height: auto;
    }
    .left-card,
    .right-card {
      padding: 20px;
    }
  }
  .title {
    font-size: 24px;
  }
  .subtitle {
    font-size: 16px;
    padding: 0;
  }
  .media-wrap {
    .explain {
      font-size: 16px;
      line-height: 30px;
    }
  }
  .right-card {
    .wax-flex {
      flex-direction: column;
    }
  }
}
</style>
